import countries_en from "./countries-en.json";
import countries_sp from "./countries-es.json";
import countries_de from "./countries-de.json";
import countries_fr from "./countries-en.json";   // TODO::: hacer el de fr
import countries_it from "./countries-en.json";   // TODO::: hacer el de it
import countries_ptBR from "./countries-ptBR.json";
import { isBelAir } from "../components/CheckIn/hotelConditions";

const countriesObject = {
  en: countries_en,
  es: countries_sp,
  de: countries_de,
  fr: countries_fr,
  it: countries_it,
  "pt-BR": countries_ptBR,
  pt: countries_ptBR,
};

export const getCountriesList = (language = "en-US", hotelId) => {
  // Normalizar el código de idioma (ejemplo: 'es-ES' -> 'es')
  const normalizedLanguage = language?.split('-')[0] || 'en';

  // console.log('1204 - language', language)
  // console.log('1204 - normalizedLanguage', normalizedLanguage)
  // console.log('1204 - countriesObject', countriesObject)

  // Obtener la lista de países según el idioma normalizado
  const countriesList = countriesObject[normalizedLanguage];

  // console.log('1204 - countriesList', countriesList)

  if (!countriesList) {
    throw new Error(`Unsupported language: ${language}`);
  }

  // Esta función vamos a definir para traernos desde el BO el array de países preferidos, con code
  // const hotelPreferredCountryCodes = getHotelPreferredCountryCodesById(hotelId);
  let hotelPreferredCountryCodes = [];

  if (hotelId === "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b" 
    || hotelId === "f33a83b9-6284-46e6-8469-b5b17de2c9ba"
    || hotelId === "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11") {
    hotelPreferredCountryCodes = [
      "AR", // Argentina
      "BR", // Brasil
      "CL", // Chile
      "CO", // Colombia
      "MX", // México
      "PE", // Perú
      "UY", // Uruguay
      "PY", // Paraguay
      "EC", // Ecuador
      "VE", // Venezuela
      "BO", // Bolivia
      "CR"  // Costa Rica
    ];
  } else if (isBelAir(hotelId)) {
    hotelPreferredCountryCodes = [
      "AR", // Argentina
      "BR", // Brasil
      "CL", // Chile
      "UY", // Uruguay
      "PY", // Paraguay
      "US", // Estados Unidos
      "DE", // Alemania
      "NL", // Países Bajos
      "FR", // Francia
      "ES"  // España
    ];
  } else {
    hotelPreferredCountryCodes = [
      "DE", // Alemania
      "AT", // Austria
      "US", // Estados Unidos
      "FR", // Francia
      "IT", // Italia
      "GB", // Reino Unido
      "ES", // España
      "NL", // Países Bajos
      "CH", // Suiza
      "BE", // Bélgica
      "DK", // Dinamarca
      "CN"  // China
    ];
  }

  // console.log('1204 - hotelPreferredCountryCodes', hotelPreferredCountryCodes)


  const preferred = [];
  const others = [];

  const _countries = Object.values(countriesList);
  const _countryMap = Object.fromEntries(
    _countries.map(c => [c.code, c])
  );
  // console.log('1204 - countryMap', _countryMap);

  hotelPreferredCountryCodes.forEach(cc => {
    // console.log('1204 - cc', cc)
    if (cc in _countryMap) {
      // console.log('1204 - si')
      preferred.push(_countryMap[cc]);
    }
  })

  _countries.forEach(country => {
    if (!hotelPreferredCountryCodes.includes(country.code)) {
      others.push(country);
    }
  });
  
  // console.log('1204 - preferred', preferred);


  // // Marcar países preferidos con un valor específico
  // Object.values(countriesObject).forEach(countries => {
  //   countries.forEach(country => {
  //     if (hotelPreferredCountryCodes.includes(country.code)) {
  //       country.value = 2; // Marcador de preferencia
  //       preferred.push(country);
  //     } else {
  //       country.value = 1; // Valor por defecto
  //       others.push(country);
  //     }
  //   });
  // });


  // Ordenar la lista de países
  others.sort((a, b) => {
    if (a.value !== b.value) {
      return b.value - a.value;
    } else {
      return a.name.localeCompare(b.name);
    }
  });

  return [...preferred, ...others ];
};
